<template>
    <div class="inline-block">
        <new-modal
            title="Set a Test Day"
            :start-open="false"
            ref="setTestDateModal"
            size="[310px]"
        >
            <template #trigger>
                <div v-if="$page.props.auth.user.test_day">
                    <div
                        class="show-datepicker-modal flex items-center gap-1 text-[16px]"
                    >
                        <div class="font-semibold">
                            {{ $page.props.auth.user.test_day.days_till }}
                        </div>

                        <div
                            v-if="
                                $page.props.auth.user.test_day?.days_till != 1
                            "
                        >
                            days
                        </div>
                        <div class="" v-else>day</div>
                        <span class="hidden md:inline"> to exam</span>
                        <div class="">
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M5 7.5L10 12.5L15 7.5"
                                    stroke="#5D6375"
                                    stroke-width="1.66667"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <span class="btn btn-sm btn-transparent"
                        >Set an Exam Date</span
                    >
                </div>
            </template>
            <template #content>
                <div class="max-w-[310px]">
                    <Datepicker
                        inline
                        name="new_test_date"
                        :hide-input-icon="true"
                        :clearable="false"
                        menu-class-name="border-none"
                        v-model="newTestDate"
                        :enable-time-picker="false"
                        :min-date="minDateString"
                        :max-date="maxDateString"
                        :auto-apply="true"
                        :utc="false"
                    >
                    </Datepicker>
                </div>
            </template>
        </new-modal>
    </div>
</template>

<script>
import NewModal from "@/Components/NewModal";

export default {
    name: "StudentTestDay",
    components: { NewModal },
    data: function () {
        return {
            newTestDate: null,
        };
    },
    methods: {
        submit: function () {
            let vm = this;

            this.$inertia.get(
                "/student/update-test-day",
                {
                    test_day: this.dayjs(vm.newTestDate)
                        .utc(true)
                        .format("YYYY-MM-DD"),
                },
                {
                    preserveState: true,
                    onSuccess: function () {
                        vm.$refs.setTestDateModal.closeModal();
                    },
                }
            );
        },
    },
    computed: {
        currentTestDate() {
            return this.dayjs(this.$page.props.auth.user.test_day?.date)
                .utc(false)
                .format("YYYY-MM-DD");
        },
        minDateString() {
            return this.dayjs().utc(false).format("YYYY-MM-DD");
        },
        maxDateString() {
            return this.dayjs().utc(false).add(1, "year").format("YYYY-MM-DD");
        },
    },

    watch: {
        newTestDate: {
            handler(newValue, oldValue) {
                this.submit();
            },
            deep: false,
        },
    },
};
</script>
